import styled, { css } from 'styled-components';
import { isRightAligned, isLeftAligned } from '../../utils/variations';
import media from '../../utils/media';
import { COMPONENT_MARGIN_BOTTOM } from '../../constants';
// TODO: See if this can be refactored to be used as a reusable container to other components i.e. Animate Content
export const Container = styled.div `
  outline: none;
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.fontFamilyBase};
  color: ${({ theme }) => theme.primaryBlack};
  position: relative;
  width: 100%;
  height: 640px;
  padding: 0 165px;
  display: flex;
  align-items: center;
  margin-bottom: ${({ hasBottomMargin }) => hasBottomMargin ? `${COMPONENT_MARGIN_BOTTOM.DESKTOP}px` : `0px`};

  ${({ alignment }) => isLeftAligned(alignment)
    ? css `
          text-align: left;
        `
    : isRightAligned(alignment)
        ? css `
          justify-content: flex-end;
        `
        : css `
          justify-content: center;
        `}

  ${media.tablet} {
    padding: 98px 0px;
    justify-content: center;
  }

  ${media.mobile} {
    flex-direction: column;
    padding: 0;
    height: auto;
    margin-bottom: ${({ hasBottomMargin }) => hasBottomMargin ? `${COMPONENT_MARGIN_BOTTOM.MOBILE}px` : `0px`};
  }
`;
// TODO: See if this can be refactored to be used as a reusable content container to other components i.e. Animate Content
export const ContentBox = styled.div `
  box-sizing: border-box;
  height: fit-content;
  width: 635px;
  padding: 60px 50px;
  background: white;

  ${({ alignment }) => !isLeftAligned(alignment) && !isRightAligned(alignment)
    ? css `
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        `
    : css `
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
        `}

  ${media.mobile} {
    width: 100%;
    padding: 30px 30px 40px;
  }

  p:last-child {
    margin-bottom: 0 !important;
  }
`;
